/**
 * @generated SignedSource<<359aab590ca2e20743a229a36bcdd5b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery$variables = {
  id: string;
};
export type InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery$data = {
  readonly internalUser: {
    readonly id: string;
    readonly loginId: string;
    readonly userName: string;
    readonly userSequence: number;
  };
};
export type InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery = {
  response: InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery$data;
  variables: InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MATInternalUser",
    "kind": "LinkedField",
    "name": "internalUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "loginId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userSequence",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eda76d49b7f1ca0d6a4bf3086c640227",
    "id": null,
    "metadata": {},
    "name": "InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery",
    "operationKind": "query",
    "text": "query InternalUserPaginatorSearchOverlayTokenField_UserValue_internalUserQuery(\n  $id: ID!\n) {\n  internalUser(id: $id) {\n    id\n    userName\n    loginId\n    userSequence\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0177e4ea4683bcc266195763863412b";

export default node;
